import { useEffect, useMemo, useRef, useState } from 'react';
/** @description Хук для отслеживания видимости элемента на странице */
export function useIntersectionObserver(params) {
  const {
    deps = [],
    elementRef,
    initSubscribeAvailable = true,
    observerOptions,
    onChange,
    onInViewport,
    onOutViewport
  } = params;
  const subscribeAvailableRef = useRef(initSubscribeAvailable);
  const intersectionsCount = useRef({
    inView: 0,
    outView: 0
  });
  const [isSubscribeAvailable, setIsSubscribeAvailable] = useState(initSubscribeAvailable);
  const subscribeState = useMemo(() => ({
    setSubscribeAvailable() {
      if (subscribeAvailableRef.current === false) {
        subscribeAvailableRef.current = true;
        setIsSubscribeAvailable(subscribeAvailableRef.current);
      }
    },
    setSubscribeUnavailable() {
      if (subscribeAvailableRef.current === true) {
        subscribeAvailableRef.current = false;
        setIsSubscribeAvailable(subscribeAvailableRef.current);
      }
    },
    get subscribeAvailable() {
      return subscribeAvailableRef.current;
    }
  }), []);
  useEffect(() => {
    if (isSubscribeAvailable && elementRef.current) {
      const observer = new IntersectionObserver(entries => {
        // тут точно не null, т.к. элемент уже в DOM и успешно отследился
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const element = elementRef.current;
        if (entries[0].isIntersecting) {
          intersectionsCount.current.inView += 1;
          onInViewport === null || onInViewport === void 0 || onInViewport({
            element,
            entries,
            intersectionsCount: intersectionsCount.current,
            observer,
            subscribeState
          });
        } else {
          intersectionsCount.current.outView += 1;
          onOutViewport === null || onOutViewport === void 0 || onOutViewport({
            element,
            entries,
            intersectionsCount: intersectionsCount.current,
            observer,
            subscribeState
          });
        }
        onChange === null || onChange === void 0 || onChange({
          element,
          entries,
          intersectionsCount: intersectionsCount.current,
          observer,
          subscribeState
        });
      }, typeof observerOptions === 'function' ? observerOptions() : observerOptions);
      observer.observe(elementRef.current);
      return () => {
        observer.disconnect();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps.concat(isSubscribeAvailable));
  return {
    subscribeState
  };
}